import React, { useState } from "react";
import { Select, SelectProps } from "@mui/material";

/**
 * FASE 05 — 2ª validação/PO 2026-07-24 (D3): Select que abre a lista automaticamente
 * ao receber foco via TAB, sem exigir clique do mouse.
 *
 * Usa keyUp da tecla Tab (que dispara no elemento recém-focado) para abrir. A seleção de
 * um item dispara onClose (não Tab), então a lista NÃO reabre indevidamente após escolher.
 */
export const SelectAutoOpen: React.FC<SelectProps> = ({
  children,
  onKeyUp,
  onOpen,
  onClose,
  ...rest
}) => {
  const [open, setOpen] = useState(false);

  return (
    <Select
      {...rest}
      open={open}
      onOpen={(e) => {
        setOpen(true);
        onOpen?.(e);
      }}
      onClose={(e) => {
        setOpen(false);
        onClose?.(e);
      }}
      onKeyUp={(e) => {
        if (e.key === "Tab") setOpen(true);
        onKeyUp?.(e);
      }}
    >
      {children}
    </Select>
  );
};
